export default __webpack_public_path__ + "static/media/FlightHotel.855bcffa.png";